export enum PaymentIntentStatus {
  RequiresPaymentMethod = 'requires_payment_method',
}
